import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../pages/Dashboard";
import { Bots } from "../pages/Bots";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { Login } from "../pages/Login/task";
import { Bloqueado } from "../pages/Bloqueado/Bloqueado";

export function AppRoutes() {
  return (
    <Routes>
      {/* Dashboard */}
      <Route
        path="/"
        element={
          <DashboardLayout>
            <Dashboard />
          </DashboardLayout>
        }
      />

      {/* Gastos route removed */}

      {/* Bots */}
      <Route
        path="/bots"
        element={
          <DashboardLayout>
            <Bots />
          </DashboardLayout>
        }
      />

      {/* Remarketing */}

      {/* Configurações */}
      <Route
        path="/settings"
        element={
          <DashboardLayout>
            <div>Configurações</div>
          </DashboardLayout>
        }
      />

      {/* Login */}
      <Route
        path="/login"
        element={<Login onLogin={() => console.log("Logado")} />}
      />

      {/* Bloqueado */}
      <Route path="/bloqueado" element={<Bloqueado />} />
    </Routes>
  );
}
